module.exports = __webpack_public_path__ + "static/media/orinocco24.48c69932.jpg";